var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('v-progress-circular',{attrs:{"size":_vm.size,"width":_vm.width,"color":"primary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }